module.exports = __webpack_public_path__ + "media/images/soar/pt-BR/appStore-0de85e1d5c9b72105bbbf1d9b0049571.png";